import classNames from 'classnames';
import React from 'react';
import { useConfig } from '../../contexts/config-context';
import { DatePickerWUT } from '../date-picker/date-picker-wut';
import Fieldset from '../fieldset';
import { classes } from './date-field-wut.st.css';
export function DateFieldWUT({ onBlur, onChange, onFocus, inputId, ariaLabelledBy, value, id, disabled, errors, hidePlaceholder, showDateLabels, required, ariaDescribedBy }) {
    const { isMobile } = useConfig();
    return /*#__PURE__*/ React.createElement(Fieldset, {
        id: inputId,
        onFocus: onFocus,
        onBlur: onBlur,
        ariaLabelledBy: ariaLabelledBy,
        className: classNames(classes.fields, {
            [classes.mobile]: isMobile
        }),
        ariaDescribedBy: ariaDescribedBy,
        required: required
    }, /*#__PURE__*/ React.createElement(DatePickerWUT, {
        inputId: inputId,
        disabled: disabled,
        errors: errors,
        hidePlaceholder: hidePlaceholder,
        showDateLabels: showDateLabels,
        required: required,
        id: id,
        onChange: onChange,
        value: value
    }));
}

//# sourceMappingURL=date-field-wut.js.map